module.exports = __webpack_public_path__ + "static/media/icon-primary-care.7ad1419a.svg";